import { useQueries } from "@tanstack/react-query";
import NewHireJourneySelect from "components/Form/Select/NewHireJourneySingleSelect";
import { NewHireJourneyId } from "models/newHire";
import { newHireJourneyQueryArgs } from "features/NewHireJourney/hooks";
import { NewHireJourney } from "models/v2/newHireJourney";
import { useMemo } from "react";

interface NewHireJourneySelectByIdsProps {
  initialNewHireJourneyIds: NewHireJourneyId[],
  selectedNewHireJourneyId: NewHireJourneyId | null,
  onChange: (e: any) => void,
  placeholder: string,
}

export default function NewHireJourneySelectByIds({
  initialNewHireJourneyIds = [],
  selectedNewHireJourneyId,
  onChange = (e: any) => { },
  placeholder,
}: NewHireJourneySelectByIdsProps) {
  const journeyQueries = useQueries({
    queries: initialNewHireJourneyIds.map((id) => newHireJourneyQueryArgs(id)),
  });

  const newHireJourneys = useMemo(
    () => journeyQueries
      .filter((q) => q.data)
      .map((q) => q.data as NewHireJourney),
    [journeyQueries],
  );

  return !!initialNewHireJourneyIds?.length && !!newHireJourneys?.length ? (
    <NewHireJourneySelect
      newHireJourneys={newHireJourneys}
      selectedNewHireJourneyId={selectedNewHireJourneyId}
      onChange={(e) => onChange(e as string)}
      placeholder={placeholder}
      isClearable
      useBasicStyles
    />
  ) : null;
}
